import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShellService } from './shell/shell.service';

const routes: Routes = [
  ShellService.childRoutes([
    {
      path: 'contacto',
      loadChildren: () =>
        import('./modules/contact/contact.module').then(m => m.ContactModule),
    },
    {
      path: 'chat',
      loadChildren: () =>
        import('./modules/chat/chat.module').then(m => m.ChatModule),
    },
    {
      path: '',
      loadChildren: () =>
        import('./modules/faqs/faqs.module').then(m => m.FaqsModule),
    },
    // fallbacks
    { path: '**', redirectTo: 'not-found' },
  ]),
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
